import React from 'react';

import Dialog from '@material-ui/core/Dialog';

class LoadingDialog extends React.Component {
    render() {
        const { open, opacity } = this.props;
        return (
            <Dialog
                fullScreen={true}
                open={open}
                onClose={this.props.handleClose}
                className={'z_index_dialog ' + (opacity ? '' : '')}
                classes={{ paper: 'opacity' }}
            >
                <div
                    className={'padding_borders_equals loading_image'}
                />
            </Dialog>
        );
    }
}

export default LoadingDialog;



// WEBPACK FOOTER //
// ./src/components/dialogs/loading.js